import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "./EntityCommand";
import { EntityCommandInformation } from "./EntityCommandInformation";
import { PartialNullable } from "./Extensions";
import { NAMESPACE } from "./_Namespace";
import { Property } from "./RadObject";
import { PermissionEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { EntityAuditDialog } from "./Ui/Dialogs/EntityAuditDialog";

import "./EntityCommandViewAuditInformation.scss";

export type EntityCommandViewAuditInformationPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandViewAuditInformationProperties = {
    [name in keyof EntityCommandViewAuditInformationPropertyValues]: Property<EntityCommandViewAuditInformationPropertyValues[name]>
};

export interface IEntityCommandViewAuditInformation extends IEntityCommand, EntityCommandViewAuditInformationProperties
{
}

export class EntityCommandViewAuditInformation extends EntityCommand<EntityCommandViewAuditInformationPropertyValues> implements IEntityCommandViewAuditInformation
{
    public static override classNamespace = NAMESPACE + "EntityCommandViewAuditInformation";
    public static override className = "EntityCommandViewAuditInformation";

    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandViewAuditInformationPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "View Audit Information",
                key: "VIEW_AUDIT_INFORMATION",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        record = entityCommandInformation.record.get();

                    if (!record || !record.id)
                        return;

                    const
                        entitySetName = entityCommandInformation.entitySetName.get();

                    if (!entitySetName)
                        return;

                    return (
                        EntityAuditDialog.getSingleInstance()
                            .openAsync({ entitySetName, recordId: record.id, applicationEntitySupportsSoftDelete: entityCommandInformation.entitySupportsSoftDelete.get() ?? false })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

